import { useMutation } from '@tanstack/react-query';
import { extractModelData } from "@/api/alternative"; 
import { ExtractModelDataRequest } from "@/types"; 
import { PostParam } from "@/types/index"; 

export function useExtractModelData(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<any, Error, ExtractModelDataRequest>({
    mutationFn: extractModelData,
    onSuccess,
    onError
  });
}